import React, { useEffect } from 'react'
import { sentry } from '../modules/app/sentry'
import { useUserAuthPayload } from '../modules/app/auth'
import * as Sentry from '@sentry/react'
import { Body, Button } from '@spritz-finance/ui'
import styled from 'styled-components'
import { Card } from '../components/Layout/Card'
import gradientBg from '../assets/img/app-bg.png'

export const SentryContext = React.createContext<any>(undefined)

const ErrorFallbackWrapper = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    background: var(--page-background, url('${gradientBg}') top/cover no-repeat);
`

const ErrorFallback = () => {
    return (
        <ErrorFallbackWrapper>
            <Card>
                <Body.Med>
                    Oh no! It looks like something broke. Our engineering team has been alerted. You
                    can also let us know in the support widget.
                </Body.Med>
                <Button.Text onClick={() => window.location.reload()}>Reload the Page</Button.Text>
            </Card>
        </ErrorFallbackWrapper>
    )
}

export const SentryProvider = ({ children }) => {
    const authPayload = useUserAuthPayload()

    useEffect(() => {
        if (!authPayload.userId) return
        sentry.setUser({
            email: authPayload.email,
            id: authPayload.userId,
            username: authPayload.userId,
        })
    }, [authPayload])

    return (
        <SentryContext.Provider value={{}}>
            <Sentry.ErrorBoundary fallback={<ErrorFallback />}>{children}</Sentry.ErrorBoundary>
        </SentryContext.Provider>
    )
}
